<template>
  <app-page-container :custom="1600" :min-height="0">
    <app-page-header
      design="new"
      title="Support workspace"
      compact
    />
    <app-tabs design="new" refined weight="medium" :tabs="tabs" />
    <router-view />
    <ticket-modal v-if="$route.query.ticket" :ticket-id="Number($route.query.ticket)" @close="closeTicket" @updated="refreshChildren" />
  </app-page-container>
</template>

<script>
import AppTabs from '@/components/AppTabs'
import TicketModal from './components/TicketModal'
import { techSupportAccess } from '@/utils/techSupportAccess'

export default {
  name: 'SupportTicketLayout',
  components: { AppTabs, TicketModal },
  data() {
    return {
      tabs: [
        { id: 'support-dashboard', name: 'support-ticket-dashboard', label: 'Dashboard', access: techSupportAccess('support') },
        { id: 'support-tasks', name: 'support-ticket-tasks', label: 'Tasks', access: techSupportAccess('support') },
        { id: 'support-tracker', name: 'support-ticket-tracker', label: 'Task tracker', access: techSupportAccess('support') },
        { id: 'support-archive', name: 'support-ticket-archive', label: 'Archive', access: techSupportAccess('support') },
        { id: 'support-manage', name: 'support-ticket-manage', label: 'Manage', access: techSupportAccess('support') }
      ]
    }
  },
  methods: {
    closeTicket() {
      const query = { ...this.$route.query }
      delete query.ticket
      this.$router.push({ name: this.$route.name, query }).catch(() => {})
    },
    refreshChildren() {
      this.$root.$emit('support-ticket-refresh')
    }
  }
}
</script>
